/* AM:BITION theme — minimal interactive layer */
(function () {
  'use strict';

  // ---- Mobil-meny ----
  const mMenu = document.querySelector('[data-mobile-menu]');
  const mOverlay = document.querySelector('[data-mobile-menu-overlay]');
  const openMobile = () => {
    if (!mMenu) return;
    mMenu.classList.add('open');
    mOverlay && mOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  const closeMobile = () => {
    if (!mMenu) return;
    mMenu.classList.remove('open');
    mOverlay && mOverlay.classList.remove('open');
    document.body.style.overflow = '';
  };
  document.querySelectorAll('[data-mobile-menu-toggle]').forEach(el =>
    el.addEventListener('click', openMobile));
  document.querySelectorAll('[data-mobile-menu-close]').forEach(el =>
    el.addEventListener('click', closeMobile));
  mOverlay && mOverlay.addEventListener('click', closeMobile);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMobile(); });
  document.querySelectorAll('.mobile-menu__link').forEach(link =>
    link.addEventListener('click', closeMobile));

  // ---- Cart drawer ----
  const overlay = document.querySelector('[data-cart-overlay]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const openCart = () => { drawer && drawer.classList.add('open'); overlay && overlay.classList.add('open'); };
  const closeCart = () => { drawer && drawer.classList.remove('open'); overlay && overlay.classList.remove('open'); };

  document.querySelectorAll('[data-cart-toggle]').forEach(el => {
    el.addEventListener('click', e => { e.preventDefault(); openCart(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(el => el.addEventListener('click', closeCart));
  overlay && overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  // ---- Refresh cart drawer via Section Rendering API ----
  // Hämtar hela sektionen på nytt från servern och byter ut markupen
  const refreshCart = async () => {
    try {
      const res = await fetch('/?sections=cart-drawer');
      if (!res.ok) throw new Error('Section fetch failed');
      const data = await res.json();
      const html = data['cart-drawer'];
      if (!html) return;

      // Parsa den nya HTML:en och plocka ut cart-drawer + cart-overlay
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(html, 'text/html');
      const newDrawer = newDoc.querySelector('[data-cart-drawer]');
      const newOverlay = newDoc.querySelector('[data-cart-overlay]');

      const currentDrawer = document.querySelector('[data-cart-drawer]');
      const currentOverlay = document.querySelector('[data-cart-overlay]');

      if (newDrawer && currentDrawer) {
        // Behåll open-klass om drawern redan är öppen
        const wasOpen = currentDrawer.classList.contains('open');
        currentDrawer.innerHTML = newDrawer.innerHTML;
        if (wasOpen) currentDrawer.classList.add('open');
      }
      if (newOverlay && currentOverlay) {
        // Overlay behöver ingen innerHTML — den är tom — men vi låter den vara
      }

      // Uppdatera cart-count överallt (t.ex. i header)
      const cart = await fetch('/cart.js').then(r => r.json());
      document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);

      // Ombind event-listeners på det nya innehållet
      bindCartEvents();
    } catch (e) {
      console.error('refreshCart failed:', e);
    }
  };

  // ---- Bind events på cart-drawer (behövs efter refresh) ----
  const bindCartEvents = () => {
    // Stäng-knapp
    document.querySelectorAll('[data-cart-close]').forEach(el => {
      el.onclick = closeCart;
    });
    // Kvantitet upp
    document.querySelectorAll('[data-cart-qty-up]').forEach(btn => {
      btn.onclick = () => {
        const key = btn.dataset.cartQtyUp;
        const span = btn.previousElementSibling;
        updateLine(key, parseInt(span.textContent, 10) + 1);
      };
    });
    // Kvantitet ner
    document.querySelectorAll('[data-cart-qty-down]').forEach(btn => {
      btn.onclick = () => {
        const key = btn.dataset.cartQtyDown;
        const span = btn.nextElementSibling;
        updateLine(key, Math.max(0, parseInt(span.textContent, 10) - 1));
      };
    });
  };

  // ---- Add to cart (AJAX) ----
  document.querySelectorAll('[data-product-form]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const formData = new FormData(form);
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST', body: formData, headers: { 'Accept': 'application/json' }
        });
        if (!res.ok) throw new Error('Add to cart failed');
        await refreshCart();
        openCart();
      } catch (err) {
        console.error(err);
        form.submit(); // graceful fallback
      }
    });
  });

  // ---- Quantity ----
  document.querySelectorAll('[data-qty-down]').forEach(btn => btn.addEventListener('click', () => {
    const input = btn.parentElement.querySelector('input');
    input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
  }));
  document.querySelectorAll('[data-qty-up]').forEach(btn => btn.addEventListener('click', () => {
    const input = btn.parentElement.querySelector('input');
    input.value = parseInt(input.value || '1', 10) + 1;
  }));

  // ---- Variant selector (flavor / option buttons) ----
  const variantsEl = document.querySelector('[data-variants]');
  if (variantsEl) {
    let variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) {}
    const optionState = {};
    document.querySelectorAll('.flavor-opt.active').forEach(b => {
      const name = b.dataset.optionName;
      if (name) optionState[name] = b.dataset.optionValue;
    });

    const findVariant = () => variants.find(v => {
      return Object.keys(optionState).every((name, i) => v.options[i] === optionState[name]);
    });

    document.querySelectorAll('.flavor-opt[data-option-name]').forEach(btn => {
      btn.addEventListener('click', () => {
        const name = btn.dataset.optionName;
        document.querySelectorAll(`.flavor-opt[data-option-name="${name}"]`)
          .forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        optionState[name] = btn.dataset.optionValue;
        const v = findVariant();
        if (v) {
          document.querySelectorAll('[data-variant-id]').forEach(el => el.value = v.id);
          if (v.featured_image && v.featured_image.src) {
            const main = document.getElementById('MainProductImg');
            if (main) main.src = v.featured_image.src;
          }
          const priceEl = document.querySelector('.product-info .price');
          if (priceEl) priceEl.textContent = (v.price / 100).toLocaleString(undefined,
            { style: 'currency', currency: window.Shopify ? Shopify.currency.active : 'EUR' });
        }
      });
    });
  }

  // ---- Gallery thumbs ----
  document.querySelectorAll('[data-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('[data-thumb]').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const main = document.getElementById('MainProductImg');
      if (main) main.src = thumb.dataset.img;
    });
  });

  // ---- Accordion ----
  document.querySelectorAll('[data-acc]').forEach(btn => {
    btn.addEventListener('click', () => btn.parentElement.classList.toggle('open'));
  });

  // ---- Cart line item update (utan sidladdning) ----
  const updateLine = async (key, qty) => {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    if (res.ok) {
      await refreshCart();
    }
  };

  // Initial bind
  bindCartEvents();
})();
